import { Switch, Redirect, BrowserRouter, Route } from "react-router-dom";
import Login from "./components/Auth/Login";
import NewPassword from "./components/Auth/ForgotPassword/NewPassword";

import { AuthProvider } from "./context/auth";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import Layout from "./layout/components/Layout";

import "./static/css/style.css";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import PrivacyPolices from "./components/TermsAndConditions/PrivacyPolices";
import LandingPage from "./components/Landing/LandingPage";
// tae

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <Redirect exact from="/" to="/login" />
          <Route
            component={TermsAndConditions}
            path="/terms-and-conditions"
            exact
          />
          <Route component={PrivacyPolices} path="/privacy-polices" exact />
          <Route path="/landing" component={LandingPage} />

          <PublicRoute component={Login} path="/login" exact />
          <Route component={NewPassword} path="/reset-password" />
          <PrivateRoute component={Layout} path="*" exact />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  );
}
